
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);

// The /app installable PWA was removed. To ensure users who previously installed
// it (or have the old service worker cached) are cleaned up, we proactively
// unregister any existing service workers and clear their caches. This prevents
// a stale, orphaned app shell from being served on future visits.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    })
    .catch(() => {
      /* no-op */
    });

  if ('caches' in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => {
        /* no-op */
      });
  }
}
